<template>
  <div>
    <menubar leftItemClass="pl-3" rightItemClass="pr-3">
      <template #rightItems>
        <b-dropdown toggle-class="btn-icon mono" right no-caret data-cy="editor-view-options-ddn">
          <template #button-content><i class="mdp-Options"></i></template>
          <b-dropdown-item link-class="icon-item" v-b-modal.view-options-modal data-cy="editor-appearance-item">
            <div class="dd-item-container">
              <span class="dd-item-icon"><i class="mdp-Preview" /></span>
              <span class="dd-item-text"> {{ $t("menubar.view") }}... </span>
            </div>
          </b-dropdown-item>
          <b-dropdown-item link-class="icon-item" v-b-modal.general-options-modal data-cy="editor-options-item">
            <div class="dd-item-container">
              <span class="dd-item-icon"> <i class="mdp-Settings" /> </span>
              <span class="dd-item-text"> {{ $t("options") }}... </span>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </menubar>
    <view-options-modal></view-options-modal>
    <general-options-modal></general-options-modal>
    <ai-texter-modal v-model="isAiTexterModalOpen" :language="aiTexterLanguage" data-cy="ai-texter-modal" />
  </div>
</template>
<script>
import emitter from "tiny-emitter/instance";
import menubar from "../../common/components/MenuBar/MenuBar.vue";
import aiTexterModal from "../components/AiTexterModal";
import generalOptionsModal from "../components/OptionsMenus/GeneralOptionsModal.vue";
import viewOptionsModal from "../components/OptionsMenus/ViewOptionsModal.vue";

export default {
  components: {
    menubar,
    aiTexterModal,
    viewOptionsModal,
    generalOptionsModal
  },
  data() {
    return {
      isAiTexterModalOpen: false,
      aiTexterLanguage: ""
    };
  },
  methods: {
    openAiModal(args) {
      this.aiTexterLanguage = args.language;
      this.isAiTexterModalOpen = args.value;
    }
  },
  mounted() {
    emitter.on("open-ai-texter", this.openAiModal);
  },

  beforeUnmount() {
    emitter.off("open-ai-texter", this.openAiModal);
  }
};
</script>
